import React from 'react';
import BreadcrumbItem from "../../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../../component/Page/Page";
import NodesForm from "./NodesForm";

class NodesFormPage extends React.Component {

  render() {
    const {match, history} = this.props;
    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Cadastros"/>];
    return (
        <Page title="Dados dos nodes" breadcrumbs={breadcrumbs}>
          <NodesForm match={match} history={history}/>
        </Page>
    );
  }
}

export default NodesFormPage;



// WEBPACK FOOTER //
// ./src/gateways/node/NodesFormPage.js